import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'

class ListComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      started: false
    }
  }

  showListItems () {
    this.props.onChange('')
    this.setState({
      started: true
    })
  }

  setSelectedItem (text) {
    this.props.onChange(text)
    this.setState({
      started: false
    })
  }

  getListItems () {
    const self = this
    let options = self.props.options
    const listItem = options.map(function (item, k) {
      if (k === 0) {
        return (
          <div key={k} style={myStyle.titleItem}>
            <span style={myStyle.textTitle}>Choisir</span>
          </div>
        )
      } else {
        return (
          <div
            style={myStyle.listItem}
            key={k}
            onClick={() => {
              let text = options[k].text
              self.setSelectedItem(text)
            }}>
            <span style={myStyle.textListItem}>{options[k].text}</span>
          </div>
        )
      }
    })
    return listItem
  }

  render () {
    const { classes } = this.props
    if (this.props.hasError && this.props.value === '') {
      return (
        <div>
          <div
            onClick={() => {
              this.showListItems()
            }}>
            <div>
              <TextField
                error
                className={classes.root}
                label={this.props.label}
                value={this.props.value}
                onChange={(event) => this.props.onChange(event.target.value)}
                margin='normal'
                InputProps={{
                  classes: this.props.classes,
                  readOnly: true
                }}
                InputLabelProps={{
                  style: { color: '#F44335', fontSize: '14px', fontWeight: 500, fontStyle: 'normal' }
                }}
              />
            </div>
          </div>
          { this.state.started
            ? <div>
              {this.getListItems()}
            </div>
            : null
          }
        </div>
      )
    } else {
      return (
        <div>
          <div
            onClick={() => {
              this.showListItems()
            }}>
            <div>
              <TextField
                className={classes.root}
                label={this.props.label}
                value={this.props.value}
                onChange={(event) => this.props.onChange(event.target.value)}
                margin='normal'
                InputProps={{
                  classes: this.props.classes,
                  readOnly: true
                }}
                InputLabelProps={{
                  style: { color: '#A6B9C8', fontSize: '14px', fontWeight: 500, fontStyle: 'normal' }
                }}
              />
            </div>
          </div>
          { this.state.started
            ? <div>
              {this.getListItems()}
            </div>
            : null
          }
        </div>
      )
    }
  }
}

const styles = theme => ({
  root: {
    width: '100%'
  },
  focused: {
    '&:after': {
      borderBottom: '2px solid #FFFFFF'
    }
  },
  underline: {
    '&:before': {
      borderBottom: '2px solid #FFFFFF'
    }
  },
  input: {
    color: '#A6B9C8'
  }
})

const myStyle = {
  titleItem: {
    width: '240px',
    height: '24px',
    margin: '2px',
    paddingTop: '6px',
    backgroundColor: '#ffffff'
  },
  textTitle: {
    marginLeft: '12px',
    fontSize: '12px',
    color: '#4880FF',
    fontWeight: 'bold',
    marginTop: '-7px'
  },
  listItem: {
    width: '240px',
    height: '30px',
    backgroundColor: '#ffffff',
    paddingTop: '6px',
    margin: '2px'
  },
  textListItem: {
    marginLeft: '12px',
    fontSize: '13px',
    color: '#6B6B6B'
  }
}

ListComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(ListComponent)
